const DIRECT_VIDEO_EXTENSION_PATTERN = /\.(mp4|webm|mov|ogg|m4v|avi|mkv|ogv|3gp)(?:[?#&/]|$)/i;
const DIRECT_IMAGE_EXTENSION_PATTERN = /\.(jpg|jpeg|png|gif|webp|bmp|svg|avif)(?:[?#&/]|$)/i;
const HLS_EXTENSION_PATTERN = /\.m3u8(?:[?#&/]|$)/i;
const VIDEO_PATH_PATTERN = /\/videos?\//i;

export const hasDirectVideoExtension = (value: string): boolean =>
  DIRECT_VIDEO_EXTENSION_PATTERN.test(value);

export const hasDirectImageExtension = (value: string): boolean =>
  DIRECT_IMAGE_EXTENSION_PATTERN.test(value);

export const hasHlsExtension = (value: string): boolean => HLS_EXTENSION_PATTERN.test(value);

export const getPathname = (url: string): string => {
  try {
    return decodeURIComponent(new URL(url).pathname);
  } catch {
    return url;
  }
};

export const isVideoUrlCandidate = (url: string): boolean => {
  const pathname = getPathname(url);

  if (hasDirectVideoExtension(pathname) || hasHlsExtension(pathname)) {
    return true;
  }

  if (VIDEO_PATH_PATTERN.test(pathname)) {
    return true;
  }

  try {
    const searchParams = new URL(url).searchParams;

    return (
      ['video', 'mp4', 'webm', 'mov'].includes(searchParams.get('type')?.toLowerCase() ?? '') ||
      ['video', 'mp4', 'webm', 'mov'].includes(searchParams.get('format')?.toLowerCase() ?? '')
    );
  } catch {
    return false;
  }
};

export const isVideoContentType = (contentType: string | null): boolean =>
  Boolean(contentType?.toLowerCase().startsWith('video/'));

export const isHlsContentType = (contentType: string | null): boolean => {
  if (!contentType) {
    return false;
  }

  const normalized = contentType.toLowerCase();

  return (
    normalized.includes('application/vnd.apple.mpegurl') ||
    normalized.includes('application/x-mpegurl') ||
    normalized.includes('audio/mpegurl')
  );
};

export const isImageContentType = (contentType: string | null): boolean =>
  Boolean(contentType?.toLowerCase().startsWith('image/'));
